import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface PhoneRegistrationResponse {
    message: string;
}

type ReturnType = Promise<AxiosResponse<PhoneRegistrationResponse>>;

const userBeginRegistrationWithSMS = (
    firstName: string,
    lastName: string,
    phone: string,
): ReturnType => {
    return Request.post(`/authentication/sms/begin-registration`, {
        first_name: firstName,
        last_name: lastName,
        phone,
    });
};
export default userBeginRegistrationWithSMS;
